import { useLocation } from 'react-router-dom';

import type { MainMenuItem } from '../side-menu-interfaces';

import { normalizePath } from './normalize-path';

export function findMatchingMenuItem(menuItems: MainMenuItem[], location: ReturnType<typeof useLocation>) {
  const path = normalizePath(location.pathname);

  return menuItems.find(item => {
    if (!item.subMenuItems?.length) {
      return item.links?.some(link => link === path) ?? false;
    }

    return item.subMenuItems.some(subItem =>
      subItem.links.some(link => link === path && !(subItem.hideIfParams && location.search))
    );
  });
}
